import type { FaqItem } from "../types/content";

export const faqItems: FaqItem[] = [
  {
    question: "Le déplacement pour le devis est-il payant ?",
    answer:
      "Non. La visite technique et le devis sont gratuits et sans engagement dans toute notre zone d'intervention (Lyon et 30 km alentour).",
  },
  {
    question: "Quels sont vos délais d'intervention en urgence ?",
    answer:
      "Pour une fuite ou une panne de chauffage, nous intervenons en moins de 2 heures, 7 jours sur 7. Les autres demandes sont planifiées sous 48 à 72 h.",
  },
  {
    question: "Puis-je bénéficier d'aides pour une pompe à chaleur ?",
    answer:
      "Oui. Étant certifiés RGE QualiPAC, nos installations ouvrent droit à MaPrimeRénov', aux primes CEE et à la TVA réduite à 5,5 %. Nous montons le dossier avec vous.",
  },
  {
    question: "Vos travaux sont-ils garantis ?",
    answer:
      "Tous nos travaux sont couverts par notre garantie décennale et notre responsabilité civile professionnelle. Les équipements bénéficient en plus de la garantie constructeur.",
  },
  {
    question: "Proposez-vous des contrats d'entretien ?",
    answer:
      "Oui, à partir de 129 € par an pour une chaudière gaz, incluant la visite annuelle obligatoire, l'attestation et la priorité de dépannage.",
  },
];
